import {Backbone} from 'Vertebrae';
import {School} from '../model/school';

export const Schools = Backbone.Collection.extend({
    _name: 'Schools',
    model: School,
});
